import { getAppUrl } from "@/services";

export default {
	state: { previewLink: null },
	mutations: {
		updatePreview(state, file) {
			if (file) {
				state.previewLink = (file.includes('data:') || file.includes('://')) ? file : getAppUrl + file;
			} else {
				state.previewLink = null;
			}
		}
	},
	actions: {
		onPreview({ commit }, file) {
			commit('updatePreview', file);
		}
	},
	getters: {
		previewLink: s => s.previewLink
	}
};
